import { TherapyDischargeNoteCourseOfTreatment } from '@uplift/api';
import { DischargeNoteReviewSection, DischargeNoteReviewSubSection } from './ReviewSections.component';
import { Box, Divider, Typography } from '@mui/material';
import { CourseOfTreatmentReviewSection } from './CourseOfTreatmentReviewSection.component';
import { Fragment } from 'react';
import { useAppointmentAssessmentsBySubmissionIds } from '@uplift/queries';
import { AppointmentAssessmentChip } from '../../../../..';


export type TherapyDischargeNoteCourseOfTreatmentSectionsProps = {
  courseOfTreatment: TherapyDischargeNoteCourseOfTreatment;
  isSidebar?: boolean;
};

export const TherapyDischargeNoteCourseOfTreatmentSections: React.VFC<TherapyDischargeNoteCourseOfTreatmentSectionsProps> = props => {
  const { courseOfTreatment } = props;

  const {
    initialAssessmentSubmissionIds = [],
    treatmentAndInterventionsNotes = [],
    initialDiagnosis = [],
  } = courseOfTreatment;

  const { data: initialAssessments = [] } = useAppointmentAssessmentsBySubmissionIds(initialAssessmentSubmissionIds);

  return (
    <Fragment>
      <CourseOfTreatmentReviewSection {...courseOfTreatment} isSidebar={props.isSidebar} />

      <Divider />

      <DischargeNoteReviewSection title="Initial Evaluation">

        <DischargeNoteReviewSubSection title="Initial Assessments" isEmpty={!initialAssessments.length} emptyMessage="Did not complete">
          <Box display="flex" gap="16px" flexWrap="wrap">
            {initialAssessments.map((a, idx) => <AppointmentAssessmentChip appointmentAssessment={a} key={idx} />)}
          </Box>
        </DischargeNoteReviewSubSection>

        <DischargeNoteReviewSubSection title="Treatment and Interventions" isEmpty={!treatmentAndInterventionsNotes.length} emptyMessage="Not Applicable">
          <Box display="flex" flexDirection="column" gap="16px">
            {treatmentAndInterventionsNotes.map((note, idx) => (
              <Typography key={idx}>{note}</Typography>
            ))}
          </Box>
        </DischargeNoteReviewSubSection>

        <DischargeNoteReviewSubSection title="Initial Diagnosis" isEmpty={!initialDiagnosis.length} emptyMessage="Not Applicable">
          <Box display="flex" flexDirection="column" gap="16px">
            {initialDiagnosis.map((d) => (
              <Typography key={d.id}>{d.code} {d.name}</Typography>
            ))}
          </Box>
        </DischargeNoteReviewSubSection>

      </DischargeNoteReviewSection>

      <Divider />

    </Fragment>
  );
};
